
import { retrieveData } from "../LocalConnection/LocalConnection";

const RefundPolicy = ({ full_name }) => {
  const loading = false;
  const globalData = JSON.parse(retrieveData("QR_GLOBAL_DATA"));

  const restaurant = globalData?.[0];
  const restaurantEmail =
    restaurant?.restaurant_email || "support@uprestro.com";
  const restaurantMobile = restaurant?.restaurant_mobile_no || "";
  const restaurantName = restaurant?.restaurant_name || full_name;
  return (
    <>
      <div style={styles.container}>
        <div style={styles.card}>
          <h1 style={styles.heading}>Refund Policy</h1>

          <p style={styles.lastUpdated}>
            <strong>
              Last Updated: {new Date().toLocaleDateString("en-GB")}
            </strong>
            {/* Outputs: 18 November 2025 */}
          </p>

          <p style={styles.text}>
            At <strong>{restaurantName || full_name}</strong>, we strive to
            provide a transparent and hassle-free payment experience. This
            Refund Policy explains when and how refunds are issued for orders
            placed at our cafe.
          </p>

          {/* Cafe-Specific Highlight Section */}
          <div style={styles.highlightBox}>
            <h2 style={styles.highlightHeading}>
              ⚠️ Important – Cafe Dine-In Only
            </h2>
            <p style={styles.highlightText}>
              🚫 <strong>No Home Delivery or Shipping</strong>
              <br />
              We are a cafe/restaurant. All items are freshly prepared and
              served directly to your table only.
            </p>
            <p style={styles.highlightText}>
              ⏱ <strong>Order Preparation Time</strong>
              <br />
              Once you place your order, your food and drinks will be served at
              your table within <strong>15–20 minutes</strong>.
            </p>
            <p style={styles.highlightText}>
              🔴 <strong>No Returns or Exchanges</strong>
              <br />
              As food items are prepared fresh and are perishable/consumable in
              nature, we cannot accept returns or exchanges once the order has
              been served.
            </p>
          </div>

          <h3 style={styles.subheading}>1. Accepted Payment Methods</h3>
          <ul style={styles.list}>
            <li>Credit & Debit Cards</li>
            <li>UPI</li>
            <li>Net Banking (where available)</li>
            <li>Cash (at the counter)</li>
          </ul>

          <h3 style={styles.subheading}>2. Unauthorized Transactions</h3>
          <p style={styles.text}>
            If you notice any unauthorized or unrecognized transaction, please
            inform our staff immediately or report it within{" "}
            <strong>30 days</strong> of the transaction for faster resolution.
          </p>

          <h3 style={styles.subheading}>3. Refund Eligibility</h3>
          <p style={styles.text}>
            Refunds may be issued in the following cases:
          </p>
          <ul style={styles.list}>
            <li>Payment deducted but order not confirmed</li>
            <li>Duplicate payment made by mistake</li>
            <li>Technical glitch during payment processing</li>
            <li>Order cancelled before preparation begins</li>
            <li>Failed transaction but amount deducted from your account</li>
          </ul>

          <h3 style={styles.subheading}>4. Refund Processing Time</h3>
          <ul style={styles.list}>
            <li>
              <strong>UPI / Cards:</strong> 5–7 business days
            </li>
            <li>
              <strong>Cash payments:</strong> Instant refund at the counter
              (where applicable)
            </li>
          </ul>
          <p style={styles.text}>
            Refunds are always credited back to the{" "}
            <strong>original payment method</strong>.
          </p>

          <h3 style={styles.subheading}>5. Payment Failures</h3>
          <p style={styles.text}>
            In case of a failed payment, kindly check your card/UPI details,
            ensure a stable internet connection, and try again. For persistent
            issues, please contact your bank or payment provider.
          </p>

          <p style={styles.contact}>
            Have questions? Feel free to speak to our friendly staff or ask at
            the counter. We're happy to help!
          </p>
        </div>
      </div>
    </>
  );
};

const styles = {
  container: {
    padding: "40px 20px",
    backgroundColor: "#f2f4f8",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
  },
  card: {
    backgroundColor: "#ffffff",
    padding: "40px",
    borderRadius: "16px",
    boxShadow: "0 6px 25px rgba(0,0,0,0.1)",
    maxWidth: "900px",
    width: "100%",
  },
  heading: {
    fontSize: "2.2rem",
    color: "#2c3e50",
    textAlign: "center",
    marginBottom: "12px",
  },
  lastUpdated: {
    textAlign: "center",
    color: "#7f8c8d",
    marginBottom: "24px",
    fontSize: "1rem",
  },
  subheading: {
    margin: "32px 0 12px",
    color: "#2c3e50",
    fontSize: "1.4rem",
  },
  text: {
    fontSize: "16px",
    lineHeight: "1.7",
    color: "#34495e",
  },
  list: {
    margin: "12px 0 20px 24px",
    lineHeight: "1.8",
    color: "#34495e",
  },
  highlightBox: {
    backgroundColor: "#fff8e1",
    borderLeft: "6px solid #ff9800",
    padding: "24px",
    borderRadius: "8px",
    margin: "32px 0",
  },
  highlightHeading: {
    color: "#e65100",
    fontSize: "1.4rem",
    marginBottom: "16px",
  },
  highlightText: {
    margin: "14px 0",
    fontSize: "16px",
    color: "#5d4037",
    lineHeight: "1.6",
  },
  contact: {
    marginTop: "50px",
    textAlign: "center",
    fontSize: "16px",
    color: "#7f8c8d",
    fontStyle: "italic",
  },
};

export default RefundPolicy;
